import type { Provider } from "../types";
import { STATE_NAMES } from "../types";
import { ProviderBadge } from "./ProviderBadge";
import { StateBadge } from "./StateBadge";

interface SuccessProps {
  provider: Provider;
  state: string;
}

export function Success({ provider, state }: SuccessProps) {
  return (
    <div className="py-6 text-center">
      <div className="flex items-center justify-center gap-3">
        <ProviderBadge provider={provider} size="lg" />
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" className="text-gray-400 flex-shrink-0">
          <path d="M4 10H16M16 10L11 5M16 10L11 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <StateBadge state={state} size="lg" />
      </div>

      <p className="mt-4 text-sm font-medium text-gray-900">Connected</p>
      <p className="mt-1 text-sm text-gray-500">
        {provider.name} &mdash; {STATE_NAMES[state] || state}
      </p>
      <p className="mt-4 text-xs text-gray-400">You can close this window.</p>
    </div>
  );
}
